/**
 * Gráfico Highcharts a partir das opções prontas vindas da API (plano §5.1).
 *
 * Highcharts é empacotado no bundle (sem CDN). Uso sem licença comercial, como no
 * legado: decisão registrada no CLAUDE.md.
 */
import Highcharts from 'highcharts';
import 'highcharts/modules/exporting';
import 'highcharts/modules/export-data';
import 'highcharts/modules/offline-exporting';
import 'highcharts/modules/full-screen';
import 'highcharts/modules/heatmap';
import 'highcharts/modules/accessibility';
// Import nomeado: o default deste pacote (CommonJS) chega como objeto do módulo no Vite.
import { HighchartsReact } from 'highcharts-react-official';
import { useMemo } from 'react';

Highcharts.setOptions({
  lang: {
    decimalPoint: ',',
    thousandsSep: '.',
    months: [
      'Janeiro',
      'Fevereiro',
      'Março',
      'Abril',
      'Maio',
      'Junho',
      'Julho',
      'Agosto',
      'Setembro',
      'Outubro',
      'Novembro',
      'Dezembro',
    ],
    shortMonths: [
      'Jan',
      'Fev',
      'Mar',
      'Abr',
      'Mai',
      'Jun',
      'Jul',
      'Ago',
      'Set',
      'Out',
      'Nov',
      'Dez',
    ],
    weekdays: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
  },
});

export interface GraficoApi {
  id: string;
  options: Highcharts.Options;
}

/** O legado (enable_fullscreen_on_dblclick) põe "viewFullscreen" no menu de exportação. */
export function pedeTelaCheia(opcoes: Highcharts.Options): boolean {
  const itens = opcoes.exporting?.buttons?.contextButton?.menuItems;
  return Array.isArray(itens) && itens.includes('viewFullscreen');
}

export function Grafico({ grafico }: { grafico: GraficoApi }) {
  // A API devolve um objeto novo a cada consulta; o Highcharts muta as opções que recebe.
  const opcoes = useMemo(() => structuredClone(grafico.options), [grafico.options]);
  const telaCheia = pedeTelaCheia(grafico.options);
  return (
    <div data-testid={`grafico-${grafico.id}`}>
      <HighchartsReact
        highcharts={Highcharts}
        options={opcoes}
        callback={(chart: Highcharts.Chart) => {
          // Duplo clique alterna tela cheia, como o wrapper do legado.
          if (telaCheia)
            chart.container.addEventListener('dblclick', () => chart.fullscreen?.toggle());
        }}
      />
    </div>
  );
}
